import * as logs from "./logs";

export const clover = {
    ...logs
}